import { Reveal } from "@/components/Reveal";

const ABOUT_IMG =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_one-on-one-yoga/artifacts/ocxrl7sp_IMG_5262.webp";

export const About = () => (
  <section id="about" data-testid="about-section" className="py-28 md:py-40">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 items-center">
      <div className="md:col-span-5 md:col-start-1">
        <Reveal>
          <p className="uppercase text-xs sm:text-sm tracking-[0.28em] font-medium text-terracotta" data-testid="about-overline">
            About
          </p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight leading-tight mt-5" data-testid="about-heading">
            A quiet practice,<br />shared one to one
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-base sm:text-lg leading-relaxed font-light tracking-wide text-olive-soft" data-testid="about-text-1">
            Hi, I'm Ophelia — a biomedical science student at the University of
            Bath, raised in the Swiss Alps, where a love of the outdoors sparked
            a lifelong passion for health and wellness.
          </p>
          <p className="mt-6 text-base sm:text-lg leading-relaxed font-light tracking-wide text-olive-soft" data-testid="about-text-2">
            Through my studies, one thing has stayed with me: how vital regular
            movement is for our mental and physical wellbeing, especially as we
            age. But I also understand that yoga classes can feel intimidating
            or out of reach — between busy work schedules, childcare, and
            accessibility concerns, it's easy to feel like there's no time or
            space for yourself.
          </p>
          <p className="mt-6 text-base sm:text-lg leading-relaxed font-light tracking-wide text-olive-soft" data-testid="about-text-3">
            That's why I started Ophelia Yoga — bringing yoga to you, in the
            comfort of your own home.
          </p>
          <p className="mt-6 text-base sm:text-lg leading-relaxed font-light tracking-wide text-olive-soft" data-testid="about-text-4">
            Everyone deserves an hour a day to invest in themselves. My classes
            follow your lead. Got a toddler who needs watching? No problem —
            we'll work around them, right there in your own space. Never tried
            yoga before and feeling nervous? We'll take things at your pace, and
            you'll be surprised how much yoga you're already weaving into daily
            life without realising it.
          </p>
          <p className="mt-6 text-base sm:text-lg leading-relaxed font-light tracking-wide text-olive-soft" data-testid="about-text-5">
            As a <span className="font-medium text-olive">certified 200-hour Hatha yoga teacher</span> with <span className="font-medium text-olive">over five years of experience in fitness and nutrition</span>, I'm also here to support you
            with lifestyle and nutrition guidance — so you can feel like the
            best version of yourself, on and off the mat.
          </p>
          <p className="mt-10 font-serif italic text-2xl text-terracotta" data-testid="about-signature">
            — Ophelia
          </p>
        </Reveal>
      </div>
      <div className="md:col-span-6 md:col-start-7">
        <Reveal delay={0.2}>
          <div className="rounded-3xl overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="Ophelia practising downward-facing dog outdoors"
              className="w-full h-[480px] md:h-[640px] object-cover object-[center_72%]"
              data-testid="about-image"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
